/**
 * Base URL for maps api script
 */
const mapsApi = 'https://maps.googleapis.com/maps/api/js?v=3';
/**
 * Base URL for recaptcha v3 api script
 */
const recaptchaApi = 'https://www.google.com/recaptcha/api.js?';

/**
 * get the sites google API Key
 * @returns {string}
 */
const getApiKey = () => {
const key = document.body.dataset.gKey;
return (key && key.length > 0) ? '&key=' + key : '';
};
/**
 * get the recaptcha google API Key
 * @returns {string}
 */
const getRecaptchaSiteKey = () => {
const key = document.body.dataset.gRecaptchaSiteKey;
return (key && key.length > 0) ? 'render=' + key : '';
};

/**
 * GoogleAPI class, contructor has flag for if script has been loaded already
 * append script to dom if it hasnt been already
 *  
 */
const _GoogleAPIs = class GoogleAPIs {
    constructor() {
        this.isMapsScriptAdded = false;
        this.mapsScriptTag = null;
        this.isRecaptchaScriptAdded = false;
        return this;
    }

    /**
     * Loads Youtube iframe api if it's not already present, and register the onYouTubeIframeAPIReady callback if passed
     * @param {function} onYouTubeIframeAPIReady
     */
    loadYoutubeIframeAPI(onYouTubeIframeAPIReady = null) {
        if (!document.querySelector('#iframe-youtube')) {
        var tag = document.createElement('script');
        tag.id = 'iframe-youtube';
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        if (onYouTubeIframeAPIReady) window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
        }
    }

    addMapsScriptToPage(callback) {
        if (typeof window.google === 'object' && typeof window.google.maps === 'object') return;
        
        if (this.isMapsScriptAdded) {
        this.mapsScriptTag.addEventListener('load', callback);
        return
        }

        this.isMapsScriptAdded = true;

        this.mapsScriptTag = document.createElement('script');
        this.mapsScriptTag.setAttribute('src', `${mapsApi}${getApiKey()}`);

        document.body.appendChild(this.mapsScriptTag);

        this.mapsScriptTag.addEventListener('load', callback);
    }

    shouldLoadRecaptcha() {
        return document.body.dataset.gRecaptchaSiteKey !== undefined;
    }

    addRecaptchaScriptToPage() {

        if (this.isRecaptchaScriptAdded) return;

        this.isRecaptchaScriptAdded = true;

        let scriptTag = document.createElement('script');
        scriptTag.setAttribute('src', `${recaptchaApi}${getRecaptchaSiteKey()}`);

        document.body.appendChild(scriptTag);
    }

    hasRecaptcha() {
        return this.isRecaptchaScriptAdded;
    }

    recaptcha(callback) {
        if (!this.isRecaptchaScriptAdded) callback();
        else {
        grecaptcha.ready(() => {
            try {
            grecaptcha.execute(document.body.dataset.gRecaptchaSiteKey, {action: 'submit'})
                .then((token) => callback(token));
            } catch (error) {
            console.error("Recaptcha error");
            console.error(error);
            callback();
            }
        });
        }
    }
};

export const GoogleAPIs =  {
      init: function() {
        window.GoogleAPIs =  new _GoogleAPIs();
    }
}